interface TabItem<T> {
    k: T;
    label: string;
    disabled?: boolean;
}

interface TabSelectorProps<T> {
    tabs: TabItem<T>[];
    active: T;
    onChange: (key: T) => void;
    className?: string;
}

const TabSelector = <T extends string>({ tabs, active, onChange, className = "" }: TabSelectorProps<T>) => {
    return (
        <div className={`flex items-center ${className}`}>
            <div className="bg-surface-muted rounded-full p-[5px] inline-flex gap-0">
                {tabs.map((tab) => {
                    const disabled = Boolean(tab.disabled);
                    return (
                        <button
                            key={tab.k}
                            type="button"
                            disabled={disabled}
                            aria-disabled={disabled}
                            className={`h-10 sm:h-11 flex items-center justify-center px-4 sm:px-5 md:px-6 py-0 rounded-full text-xs sm:text-sm font-bold leading-none whitespace-nowrap transition-all duration-200 no-underline ${disabled
                                ? "cursor-not-allowed text-slate-400 opacity-60 hover:bg-transparent hover:no-underline"
                                : active === tab.k
                                    ? "bg-gradient-to-r from-primary-600 to-primary-700 text-white shadow-brand hover:translate-y-[-1px] hover:no-underline"
                                    : "text-slate-600 hover:text-primary-700 hover:bg-primary-50 hover:no-underline"
                                }`}
                            onClick={() => {
                                if (!disabled) onChange(tab.k);
                            }}
                        >
                            {tab.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default TabSelector;